const BASE_PATH = process.env.VUE_APP_STATIC_BASE + '/common-static/images/';
let default_avatar;
export const defaultAvatar = `${BASE_PATH}default_avatar.png`;
export const defaultLogo = `${BASE_PATH}default_logo.png`;
export function getDefaultAvatar() {
  !default_avatar && (default_avatar = sessionStorage.getItem('default_avatar'));
  return default_avatar || defaultAvatar;
}
